import React, { useState, useEffect, useContext } from "react";
import { useForm, Controller } from "react-hook-form";
import { useHistory } from "react-router-dom";
import CardWrap from "../Common/CardWrap";
import { storeService } from "../../Services/store.service";
import { globalServices } from "../../Services/global.service";
import ResultModal from "../Common/ResultModal";
import { useTranslation } from "react-i18next";
import Tooltip from "../Common/Tooltip";
import Select from "react-select";
import {
  address,
  numbersOnly,
  storeTag,
  lettersAndNumbers,
} from "../../Config/Regex";
import { GlobalContext } from "../../Contexts/GlobalContextProvider";
import { AuthContext } from "../../Contexts/AuthContext";
import { validationService } from "../../Services/validation.service";
import AsyncSelect from "react-select/async";

const StoreAdd = (props) => {
  const { locName, locTenant, locStore } = useContext(GlobalContext);
  const { userId, roleId, tenantId, tenantName } = useContext(AuthContext);
  const { t: translator } = useTranslation();
  const [countries, setCountries] = useState([]);
  const [tenants, setTenants] = useState([]);
  const [postOffices, setPostOffices] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [modal, setModal] = useState({
    title: "",
    text: "",
    show: false,
    btnClass: "",
    success: true,
  });
  const [tenantObj, setTenantObj] = useState(null);
  const { register, handleSubmit, errors, control, setValue } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });

  useEffect(() => {
    globalServices
      .getCountries()
      .then((res) => setCountries(res.data))
      .catch((err) => console.log(err));

    globalServices
      .getPostOffices()
      .then((data) => {
        setPostOffices(data.data);
      })
      .catch(() => history.push("/Error"));
  }, []);

  const promiseOptions = (inputValue) => {
    return globalServices
      .getTenants(
        Number(localStorage.getItem("tenantId")) > 0 ? userId : null,
        inputValue,
        Number(locTenant)
      )
      .then((res) => {
        if (Number(locTenant) > 0) {
          setValue("tenantId", {
            id: Number(locTenant),
            value: Number(locTenant),
            label: res.data.filter((e) => e.id === Number(locTenant))[0].name,
          });
          setTenantObj({
            id: locTenant,
            value: locTenant,
            label: res.data.filter((e) => e.id === Number(locTenant))[0].name,
          });
        }
        var result = res.data.map((e) => ({
          id: e.id,
          label: e.name,
          value: e.id,
        }));
        result.unshift({
          id: 0,
          label: translator("SelectTenant-Choose"),
          oib: "",
        });
        return result;
      })
      .catch((err) => err);
  };

  const history = useHistory();
  const [city, setCity] = useState();
  const getCity = (id, postal) => {
    globalServices
      .getCityByPostOffice(id)
      .then((res) => {
        document.getElementsByName("city")[0].value = res.data.data.name;
        setCity(res.data.data.name);
        document.getElementsByName("city-hidden")[0].value = res.data.data.name;
      })
      .catch(() => history.push("/Error"));
  };

  const onSubmit = (data) => {
    storeService
      .create({
        tenantId: Number(tenantObj.id),
        description: data.description,
        tag: data.tag,
        type: Number(data.type),
        footerNote: data.footerNote,
        priceListId: data.priceListId,
        street: data.street,
        streetNumber: Number(data.streetNumber),
        streetNumberExtension: data.streetNumberExtension,
        city: data.city,
        postalNumber: data.postalNumber.value,
        countryId: Number(data.countryId),
      })
      .then((res) => {
        res.data.success
          ? setModal({
            show: true,
            title: translator("StoreAdd-SuccesModal-Title"),
            text: translator("StoreAdd-SuccesModal-Text"),
            btnClass: "btn btn-primary",
            success: true,
          })
          : setModal({
            show: true,
            title: translator("StoreAdd-UnsuccesModal-Title"),
            text: translator("StoreAdd-UnsuccesModal-Text"),
            btnClass: "btn btn-primary",
            success: false,
          });
      })
      .catch((err) =>
        setModal({
          show: true,
          title: translator("StoreAdd-UnsuccesModal-Title"),
          text: translator("StoreAdd-UnsuccesModal-Text"),
          btnClass: "btn btn-primary",
          success: false,
        })
      );
  };

  const goBack = () => {
    let backedId = 0;
    switch (locName) {
      case "tenants":
        backedId = locTenant != 0 ? locTenant : "";
        break;
      case "stores":
        backedId = locStore != 0 ? locStore : "";
        break;
      default:
        history.push("/stores");
    }
    history.push(`/${locName}/${backedId}`);
  };

  const handleCancel = () => {
    goBack();
  };

  const handleClose = () => {
    setModal({ ...modal, show: false });
    if (modal.success === true) {
      goBack();
    }
  };

  return (
    <CardWrap subtitle={translator("StoreAdd-Subtitle")}>
      <form onSubmit={handleSubmit(onSubmit)} className="row">
        <div className="col-lg-4">
          <fieldset className="scheduler-border">
            <legend className="scheduler-border">
              {translator("StoreAdd-GeneralData")}
            </legend>

            <div className="form-group">
              <label htmlFor="tag">{translator("StoreAdd-Tenants")}</label>{" "}
              <Tooltip text={translator("Store-Tenant-Msg")} />
              <Controller
                as={AsyncSelect}
                control={control}
                autoComplete="off"
                name="tenantId"
                placeholder={translator("Select-Tenant")}
                rules={{
                  validate: function (value) {
                    if (!value) return false;
                    return value.value === 0 ? false : true;
                  },
                }}
                onChange={function (event) {
                  setTenantObj({
                    id: event[0].id,
                    label: event[0].label,
                    value: event[0].value,
                  });

                  return event[0];
                }}
                defaultOptions={true}
                loadOptions={promiseOptions}
              />
              {errors.tenantId && errors.tenantId.type === "validate" && (
                <p className="text-danger">
                  {translator("ValidationMsg-RequiredField")}
                </p>
              )}
            </div>
            <div className="form-group">
              <label> {translator("StoreAdd-Description")}</label>{" "}
              <Tooltip text={translator("Store-Description-Msg")} />
              <textarea
                id="textArea"
                rows="2"
                className="form-control"
                name="description"
                ref={register({ required: true, maxLength: 100 })}
              />
              {errors.description && errors.description.type === "required" && (
                <p className="text-danger">
                  {translator("ValidationMsg-RequiredField")}
                </p>
              )}
              {errors.description &&
                errors.description.type === "maxLength" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-MaxLength100")}
                  </p>
                )}
            </div>
            <div className="form-group">
              <label htmlFor="tag">{translator("StoreAdd-Tag")}</label>{" "}
              <Tooltip text={translator("Store-Tag-Msg")} />
              <input
                type="text"
                className="form-control"
                name="tag"
                ref={register({
                  //required: true,
                  pattern: storeTag,
                  validate: () =>
                    validationService.validateStoreTag(
                      document.getElementsByName("tag")[0].value,
                      tenantObj.id
                    ),
                })}
              />
              {errors.tag && (
                <>
                  {/* {errors.tag.type === "required" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-RequiredField")}
                    </p>
                  )} */}
                  {errors.tag.type === "validate" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-TagAlreadyExist")}
                    </p>
                  )}
                  {errors.tag.type === "pattern" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-StoreTag")}
                    </p>
                  )}
                </>
              )}
            </div>
            <div className="form-group">
              <label htmlFor="type">{translator("StoreAdd-Type")}</label>
              <select
                name="type"
                className="form-control"
                ref={register({ required: true })}
              >
                <option selected={true} disabled value="">
                  {translator("StoreUpdate-SelectOption-ChooseType")}
                </option>
                <option value={1}>
                  {translator("StoreUpdate-SelectOption-Fixed")}
                </option>
                <option value={2}>
                  {translator("StoreUpdate-SelectOption-Mobile")}
                </option>
              </select>
              {errors.type && errors.type.type === "required" && (
                <p className="text-danger">
                  {translator("ValidationMsg-RequiredField")}
                </p>
              )}
            </div>
            <div className="form-group">
              <label htmlFor="footerNote">
                {translator("StoreAdd-FooterText")}
              </label>{" "}
              <Tooltip text={translator("Store-FooterText-Msg")} />
              <input
                type="text"
                className="form-control"
                name="footerNote"
                ref={register({ required: true, maxLength: 250 })}
              />
              {errors.footerNote && (
                <>
                  {errors.footerNote.type === "required" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-RequiredField")}
                    </p>
                  )}
                  {errors.footerNote.type === "maxLength" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-MaxLength250")}
                    </p>
                  )}
                </>
              )}
            </div>
          </fieldset>
        </div>
        <div className="col-lg-4">
          <fieldset className="scheduler-border">
            <legend className="scheduler-border">
              {translator("StoreAdd-AdressData")}
            </legend>
            <div className="form-group">
              <label htmlFor="street">{translator("StoreAdd-Street")}</label>{" "}
              <Tooltip text={translator("Store-Street-Msg")} />
              <input
                type="text"
                className="form-control"
                name="street"
                ref={register({
                  required: true,
                  maxLength: 150,
                  pattern: address,
                })}
              />
              {errors.street && (
                <>
                  {errors.street.type === "required" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-RequiredField")}
                    </p>
                  )}

                  {errors.street.type === "maxLength" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-MaxLength150")}
                    </p>
                  )}
                  {errors.street.type === "pattern" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-LettersOnly")}
                    </p>
                  )}
                </>
              )}
            </div>
            <div className="form-row">
              <div className="form-group col-md-7">
                <label htmlFor="streetNumberExtension">
                  {translator("StoreAdd-StreetNumber")}
                </label>{" "}
                <Tooltip text={translator("Store-StreetNumber-Msg")} />
                <input
                  type="text"
                  className="form-control"
                  name="streetNumber"
                  ref={register({
                    required: true,
                    pattern: numbersOnly,
                    maxLength: 6,
                  })}
                />
                {errors.streetNumber &&
                  errors.streetNumber.type === "required" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-RequiredField")}
                    </p>
                  )}
                {errors.streetNumber &&
                  errors.streetNumber.type === "maxLength" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-MaxLength6")}
                    </p>
                  )}
                {errors.streetNumber &&
                  errors.streetNumber.type === "pattern" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-NumberOnly")}
                    </p>
                  )}
              </div>
              <div className="form-group col-md-5">
                <label htmlFor="streetNumber">
                  {translator("StoreAdd-StreetNumberAddition")}
                </label>{" "}
                <Tooltip text={translator("Store-StreetNumberAdittion-Msg")} />
                <input
                  type="text"
                  className="form-control"
                  name="streetNumberExtension"
                  ref={register({ maxLength: 10 })}
                />
                {errors.streetNumberExtension && (
                  <>
                    {errors.streetNumberExtension.type === "maxLength" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-MaxLength10")}
                      </p>
                    )}
                  </>
                )}
              </div>
            </div>
            <div className="form-row">
              <div className="form-group col-md-5">
                <label htmlFor="streetNumberExtension">
                  {translator("StoreAdd-ZipCode")}
                </label>{" "}
                <Tooltip text={translator("Store-ZipCode-Msg")} />
                <Controller
                  as={Select}
                  options={
                    postOffices &&
                    postOffices.map((p) => ({
                      id: p.id,
                      label: p.name,
                      value: p.name,
                    }))
                  }
                  name="postalNumber"
                  placeholder=""
                  rules={{ required: true }}
                  control={control}
                  onChange={function (event) {
                    getCity(event[0].id, event[0].label);
                    return event[0];
                  }}
                />
                {errors.postalNumber &&
                  errors.postalNumber.type === "required" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-RequiredField")}
                    </p>
                  )}
              </div>
              <div className="form-group col-md-7">
                <label htmlFor="streetNumber">
                  {translator("StoreAdd-City")}
                </label>{" "}
                <Tooltip text={translator("Store-City-Msg")} />
                <input
                  type="hidden"
                  className="form-control"
                  name="city-hidden"
                  ref={register({ required: true })}
                />
                <input
                  type="text"
                  className="form-control"
                  name="city"
                  ref={register({ required: true })}
                />
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="countryId">{translator("StoreAdd-State")}</label>
              {countries.length > 0 && (
                <select
                  className="form-control"
                  name="countryId"
                  ref={register({
                    validate: (value) => value !== "-1",
                  })}
                  defaultValue={1}
                >
                  {countries &&
                    countries.map((c) => (
                      <option selected={true} value={c.id}>
                        {c.name}
                      </option>
                    ))}
                </select>
              )}
              {errors.countryId && errors.countryId.type === "validate" && (
                <p className="text-danger">
                  {translator("ValidationMsg-RequiredField")}
                </p>
              )}
            </div>
          </fieldset>
        </div>

        <div
          className="container-fluid"
          style={{
            display: "flex",
            paddingTop: "3%",
            justifyContent: "flex-end",
          }}
        >
          <button className="btn btn-outline-secondary" onClick={handleCancel}>
            {translator("Btn-Cancel")}
          </button>
          &nbsp;
          <button className="btn btn-primary" type="submit">
            {translator("Btn-Save")}
          </button>
        </div>
      </form>

      <ResultModal
        show={modal.show}
        title={modal.title}
        text={modal.text}
        btnClass={modal.btnClass}
        handleClose={handleClose}
      />
    </CardWrap>
  );
};

export default StoreAdd;
